import type { PropsWithChildren, Ref } from 'react';
import styled from 'styled-components';
import { PerspectivesFooter } from '@ardoq/perspectives-sidebar';
import { SIDEBAR_MENU_SELECTOR } from '@ardoq/sidebar-menu';
import { SubLevelPageHeader } from '../SubLevelPageHeader';
import type { ViewOptionsPerspectivesHeaderProperties } from './types';

const ViewOptionsPerspectivesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${SIDEBAR_MENU_SELECTOR} {
    border: none;
  }
`;

const ScrollContainer = styled.div`
  overflow-y: auto;
  display: flex;
  flex: 1;
`;

export type ViewOptionsPerspectivesPageLayoutProps =
  ViewOptionsPerspectivesHeaderProperties & {
    onBackButtonClick: VoidFunction;
    onApply: VoidFunction;
    onClose: VoidFunction;
    onClear: VoidFunction;
  };

type ViewOptionsPerspectivesPageLayoutArgs = PropsWithChildren<
  ViewOptionsPerspectivesPageLayoutProps & {
    ref?: Ref<HTMLDivElement>;
  }
>;

export const ViewOptionsPerspectivesPageLayout = ({
  ref,
  title,
  children,
  knowledgeBaseLink,
  shareFeedbackUrl,
  isNew,
  i18nLocale,
  onBackButtonClick,
  onApply,
  onClose,
  onClear,
}: ViewOptionsPerspectivesPageLayoutArgs) => (
  <ViewOptionsPerspectivesContainer ref={ref}>
    <SubLevelPageHeader
      title={title}
      knowledgeBaseLink={knowledgeBaseLink}
      shareFeedbackUrl={shareFeedbackUrl}
      isNew={isNew}
      onBackButtonClick={onBackButtonClick}
      onCloseClick={onClose}
      i18nLocale={i18nLocale}
    />
    <ScrollContainer>{children}</ScrollContainer>
    <PerspectivesFooter
      onApply={onApply}
      onClose={onClose}
      onClear={onClear}
      i18nLocale={i18nLocale}
    />
  </ViewOptionsPerspectivesContainer>
);
